var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableBookingTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.853 11.147l-.538-.539-.865-.863 1.394-1.395c.196-.195.195-.512 0-.707-.052-.051-.114-.09-.182-.116L7.177 5.9c-.519-.188-1.092.081-1.28.6-.08.22-.08.46 0 .68l1.631 4.485c.059.16.195.28.362.317.035.008.072.012.108.012.133 0 .26-.053.354-.147l1.393-1.397.863.864.539.538c.198.192.515.187.707-.012.187-.194.187-.501 0-.695v.002z",
    transform: "translate(-69 -320) translate(69 320)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10c-2.761 0-5-2.238-5-5C0 2.24 2.239 0 5 0s5 2.239 5 5c0 .276-.224.5-.5.5S9 5.276 9 5c0-2.209-1.79-4-4-4S1 2.791 1 5c0 2.21 1.79 4 4 4 .276 0 .5.224.5.5s-.224.5-.5.5z",
    transform: "translate(-69 -320) translate(69 320)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.042 7.81c-.066 0-.13-.013-.192-.038-1.53-.635-2.255-2.39-1.62-3.921.636-1.53 2.392-2.255 3.922-1.62.734.305 1.318.89 1.621 1.624.11.254-.006.548-.26.658-.253.11-.547-.007-.657-.26l-.006-.016c-.424-1.02-1.594-1.504-2.614-1.08-1.02.423-1.504 1.593-1.081 2.613.203.489.59.877 1.079 1.08.255.106.376.398.27.653-.077.188-.26.31-.462.31V7.81z",
    transform: "translate(-69 -320) translate(69 320)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableBookingTime);
export default __webpack_public_path__ + "static/media/tableBookingTime.a1a56b39.svg";
export { ForwardRef as ReactComponent };